import { VendorStockInRequestPage } from "@/features/vendor-app/pages/VendorStockInRequestPage";
import { createFileRoute } from "@tanstack/react-router";

export type VendorStockInRequestSearch = {
	number?: string;
	dateStart?: string;
	dateEnd?: string;
	status?: string;
};

const str = (v: unknown): string | undefined =>
	typeof v === "string" && v !== "" ? v : undefined;

export const Route = createFileRoute("/vendor/stock-in-request/")({
	validateSearch: (
		search: Record<string, unknown>,
	): VendorStockInRequestSearch => ({
		number: str(search.number),
		dateStart: str(search.dateStart),
		dateEnd: str(search.dateEnd),
		status: str(search.status),
	}),
	component: VendorStockInRequestPage,
});
